import script from "./SupportOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupportOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./SupportOverlay.vue?vue&type=style&index=0&id=ba54a3f6&lang=scss&scoped=true"

import exportComponent from "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba54a3f6"]])

export default __exports__